import isNumber from 'lodash-es/isNumber'
import { FC } from 'react'

import { Media } from '@syconium/little-miss-figgy'

import { siteName } from '../../../../../constants/figs'
import { ProductReviewsContainer } from '../../../../../containers/ProductReviewsContainer'
import { ReviewsProductGroupDataService } from '../../../../../containers/ReviewsProductGroupDataService'

import { AverageFit } from './AverageFit'
import { BaselineImage } from './BaselineImage'
import { FitSurvey } from './FitSurvey'
import { StarDistribution } from './StarDistribution'
import { Body, Spacer } from './styles'
import { FitSurveyItem } from './types'

export const ReviewBaseline: FC<{ fitFields?: Array<FitSurveyItem> }> = ({ fitFields }) => {
  const { data: productData } = ReviewsProductGroupDataService.useContainer()
  const { results } = ProductReviewsContainer.useContainer()

  const productName = productData?.product.seoTitle ?? productData?.product?.title
  const averageFit = results?.averageFit
  const averageScore = results?.averageScore ?? 0
  const totalCount = results?.totalReviews ?? 0

  const details =
    totalCount > 0 ? (
      <>
        <Spacer>
          <StarDistribution rating={averageScore} totalReviews={totalCount} />
        </Spacer>

        {isNumber(averageFit) && (
          <Spacer>
            <AverageFit fit={averageFit} />
          </Spacer>
        )}
      </>
    ) : null

  return (
    <Body>
      <BaselineImage imageSrc={productData?.product.image} title={productName ?? siteName}>
        <Media greaterThanOrEqual='md'>{details}</Media>
      </BaselineImage>

      <Media lessThan='md'>{details}</Media>

      {!!fitFields && (
        <Spacer>
          <FitSurvey fitFields={fitFields} />
        </Spacer>
      )}
    </Body>
  )
}
